import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=034321ba&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports